import { defineStore } from 'pinia'
import { ref } from 'vue'
export type EventView = 'athlete' | 'staff'
const staffRoles = ['owner','admin','selector','support','headcoach','assistantcoach','programcoach','sysadmin'] as const
type EventRoles = Partial<Record<'athlete' | (typeof staffRoles)[number], unknown>>
export interface EventViewScope { viewerId: string; clubId: string; seasonId: string; eventId: string }
export function eventViewKey(scope: EventViewScope) { return JSON.stringify([scope.viewerId, scope.clubId, scope.seasonId, scope.eventId]) }
export function eventViewAccess(roles: EventRoles = {}) {
  return { athlete: roles.athlete === true, staff: staffRoles.some(role => roles[role] === true) }
}
export function resolveEventView(preference: EventView | undefined, roles: EventRoles): EventView | null {
  const access = eventViewAccess(roles)
  if (preference && access[preference]) return preference
  return access.staff ? 'staff' : access.athlete ? 'athlete' : null
}
export const useEventViewStore = defineStore('eventView', () => {
  const preferences = ref<Record<string, EventView | undefined>>({})
  function preference(scope: EventViewScope) {
    const key = eventViewKey(scope)
    if (preferences.value[key]) return preferences.value[key]
    try { const saved = localStorage.getItem(`cs-event-view:${key}`); if (saved === 'athlete' || saved === 'staff') return saved } catch { /* Browser storage is optional. */ }
    return undefined
  }
  function select(scope: EventViewScope, view: EventView, roles: EventRoles) {
    if (!scope.viewerId || !eventViewAccess(roles)[view]) return false
    const key = eventViewKey(scope)
    preferences.value[key] = view
    try { localStorage.setItem(`cs-event-view:${key}`, view) } catch { /* Keep the in-memory preference. */ }
    return true
  }
  return { preference, select }
})
